import colors from '@mathflat/common/style/colors'
import * as React from 'react'
import { useEffect, useState } from 'react'

import { _OldButton } from '@/component/atoms/Button/_OldButton'
import { Icon } from '@/component/atoms/Icon'
import modalService from '@/service/modal.service'

import WarningModalStyled from './WarningModal.style'

type Props = {
  content: React.ReactNode
  actionButtonText?: string
  cancelButtonText?: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
  onCancelClick?: React.MouseEventHandler<HTMLButtonElement>
}
const WarningModal = ({
  content,
  actionButtonText = '확인',
  cancelButtonText = '취소',
  onClick,
  onCancelClick = modalService.closeModal,
}: Props) => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    return () => {
      setLoading(false)
    }
  }, [])

  return (
    <WarningModalStyled>
      <div className="warning-modal-header">
        <Icon name="alert_error_fill" color={colors.red.$300} size={24} />
        <h2>주의</h2>
      </div>
      <div className="warning-modal-body">{content}</div>
      <div className="warning-modal-footer">
        <_OldButton
          theme="primary-caution"
          loading={loading}
          onClick={async (e) => {
            setLoading(true)
            await onClick(e)
            setLoading(false)
          }}
        >
          {actionButtonText}
        </_OldButton>
        <_OldButton theme="default" onClick={onCancelClick}>
          {cancelButtonText}
        </_OldButton>
      </div>
    </WarningModalStyled>
  )
}

export default WarningModal
